<template>
  <div class="body">
    <div class="language">
      <van-button class="switch" type="info" @click= 'zhLogin'>中文</van-button>
    </div>
    <div class="logo">
      <img src="../../assets/images/loginlogoenglish.png">
    </div>
    <div class="login">

      <van-form autocomplete="off">
        <van-field
        v-model="email"
        label="文本"
        placeholder="Email"
        />
        <van-field style="margin-top: 20px;"
        v-model="password"
        type="password"
        label="文本"
        placeholder="Password"
        />
      </van-form>
      <van-button size="small" class="btn" @click='loginClick'>Login</van-button>
      <div class="cl-register" @click="onRegister">Register</div>
    </div>

    <div style="position:absolute;bottom:30px;width:100%;color:#B28814;font-size:8px;font-weight: bold;">
      <div class="namediv2" >
        <span class="copyright1"><a target="_blank" style="display:inline-block;text-decoration: underline;color:#B28814;" href="http://beian.miit.gov.cn">辽ICP备：辽B-2-4-20080120-23</a> COPYRIGHT © 2019</span>
      </div>
      <div class="namediv2" >
        <span class="copyright1">WIFFA SHIPPINGTECH CO., LTD. All RIGHTS RESERVED</span>
      </div>
      <div class="namediv2" >
        <span class="copyright1">大连万发联合航贸科技有限公司</span>
      </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'loginEn',
  data () {
    return {
      email:'',
      password:''
    }
  },
  components: {

  },
  created () {

  },
  mounted() {
    localStorage.setItem('locale','en')
    this.$i18n.locale = localStorage.getItem('locale')
  },
  methods: {
    zhLogin(){
      this.$router.push({
        name: "login"
      })
    },
    //英文登录接口
    loginClick() {
      let email = this.email
      let password = this.password
      if(email.length == '0'){
        this.$toast('Please enter email address')
        return;
      } else if(password.length < '8' || password.length > '16'){
        this.$toast('Please enter the correct password of 8 to 16 characters or Numbers')
        return;
      }
      this.$axios.post('/clientUserLoginEn/login',{
        "email" : email,
        "password": password
      })
      .then(response=> {
        console.log('英文登录接口返回信息:↓↓↓')
        console.log(response)
        localStorage.setItem('locale','en')
        this.$i18n.locale = localStorage.getItem('locale')
        let status = response.code
        let message = response.msg
        let data = response.data
        if(status == '0'){
          localStorage.setItem('userID',data.id)
          localStorage.setItem('mobile',data.mobile)
          localStorage.setItem('realName',data.realName)
          localStorage.setItem('userStatus',data.userStatus)
          localStorage.setItem('companyName',data.companyNameEn)
          this.userPermission()
        }else if(status == '-1'){
          this.$toast(message)
        }
      })
      .catch((error) => {
        console.log(error);
        this.abnormalSituation()
      });
    },
    //获取用户权限
    userPermission() {
      this.$axios.get('/menu/userPermission',{
        params: {

        }
      })
      .then(response => {
        console.log('获取用户权限接口返回数据:↓↓↓')
        console.log(response)
        let status = response.code
        let message = response.msg
        let data = response.data
        if(status==0){
          // 缓存权限列表用于主页面显示tabbar判断
          localStorage.setItem('permissionList',data)
          // 根据权限列表决定登录后跳转的页面地址：ex用户拥有所有权限跳转到企业账户总览，用户只有个人账号权限跳转到个人账户总览
          // 判断顺序为tabbar显示顺序
          // 企业账户总览
          if(data && data.indexOf('user:company:account') != -1){
            this.$router.push({
              name: "accountmodel"
            })
          // 企业关联账号管理
          }else if(data && data.indexOf('user:company:accountmanage') != -1){
            this.$router.push({
              name: "managementmodel"
            })
          // 个人账户总览
          }else if(data && data.indexOf('user:person:account') != -1){
            this.$router.push({
              name: "personalmodel"
            })
          }
        }else if(status==-1){
          this.$toast(message)
        }
      })
      .catch((error) => {
        console.log(error);
        this.abnormalSituation()
      });
    },
    onRegister(){
      this.$router.push({
        name: "registerEn",
        query: {

        }
      })
    }
  }
}
</script>

<style scoped>
  *{
    box-sizing: border-box;
    outline: none;
    list-style: none;
    font-size: inherit;
    text-decoration: none;
    font-style: normal;
    resize: none;
    font-family: Microsoft YaHei!important;
  }
  html,body,#app{
    height: 100%;
  }
  .body{
    width: 100%;
    height: 100%;
    background: url(../../assets/images/clbackgroundimage.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
  }
  .login{
    width: 80%;
    top: 30%;
    margin-left: 10%;
    padding: 20px;
    border-radius: 2px;
    position: fixed;
  }
  /deep/ .van-field__label{
    display: none!important;
  }
  /deep/ .van-field{
/*    padding-bottom: 10px;
    margin-top: 20px; */
  }
  /deep/ .van-cell--center{
    padding-bottom: 10px;
    margin-top: 20px;
  }
  /deep/ .van-button--primary{
    background-color: #C9B25F;
    border: 1px solid #C9B25F;
  }
  .btn{
    width: 100%;
    height: 40px;
    margin: 60px auto 0;
    border-radius: 4px;
    display: block;
    color: white;
    background-color: #fd7d00;
    border: #fd7d00 solid 1px;
  }
  /deep/ .van-cell::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border: transparent solid 1px;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
  .cl-register{
    width: 60px;
    text-align: center;
    font-size: 14px;
    color: #fd7d00;
    margin: 20px auto 5px;
    border-bottom: #fd7d00 solid 1px ;
    text-decoration: none;
  }
  .logo{
    width: 100%;
    overflow: hidden;
    position: fixed;
    top: 20%;
    text-align: center;
  }
  .logo img{
    width: auto;
    height: 35px;
    margin: auto;
  }
  .van-button--primary{
    padding: 0 15px;
  }
  /deep/ .van-field__control{
    padding-left: 10px;
    border: #C9B25F solid 1px;
    height: 40px;
    background-color: white;
  }
  /deep/ .van-cell{
    margin: 0;
    padding: 10px;
  }
  .language{
    margin-top: 20px;
    margin-right: 20px;
    float: right;
  }
  .switch{
    background-color: #fd7d00;
    border: #fd7d00 solid 1px;
    color: white;
    width: 100px;
    height: 35px;
    border-radius: 10px;
  }
  /deep/ .van-cell{
    padding: 0;
  }
  .namediv2{
    width: 100%;
    display: flex;
    justify-content: center;
  }
</style>
